import useLocale from '@hellodarwin/core/lib/features/providers/locale-provider';
import { useCallback, useEffect, useRef, useState, } from 'react';
import useContentfulApi from '../../../../api';
import { useContentfulDispatch, useContentfulSelector, } from '../../../../redux/hooks';
import { fetchPageComponent } from '../../../../redux/pages.slice';
import { selectPageComponentById } from '../../../../redux/selectors';
const useScrollingBannerTimer = ({ itemsIndex, interval, }) => {
    var _a;
    const [currentItemIndex, setCurrentItemIndex] = useState(itemsIndex === null || itemsIndex === void 0 ? void 0 : itemsIndex[0]);
    const dispatch = useContentfulDispatch();
    const api = useContentfulApi();
    const { selectedLocale } = useLocale();
    const itemsLoaded = useRef([]);
    useEffect(() => {
        if (itemsLoaded.current.length === (itemsIndex === null || itemsIndex === void 0 ? void 0 : itemsIndex.length))
            return;
        setCurrentItemIndex(itemsIndex === null || itemsIndex === void 0 ? void 0 : itemsIndex[0]);
        itemsIndex === null || itemsIndex === void 0 ? void 0 : itemsIndex.forEach((itemIndex) => {
            if (itemsLoaded.current.includes(itemIndex))
                return;
            dispatch(fetchPageComponent({
                api,
                locale: selectedLocale,
                entryId: itemIndex,
                contentType: 'simpleColumnComponent',
            }));
            itemsLoaded.current.push(itemIndex);
        });
    }, [api, dispatch, itemsIndex, selectedLocale]);
    const currentItem = useContentfulSelector((state) => selectPageComponentById(state, currentItemIndex));
    const [isPaused, setIsPaused] = useState(false);
    const timerRef = useRef(null);
    const itemsCount = (_a = itemsIndex === null || itemsIndex === void 0 ? void 0 : itemsIndex.length) !== null && _a !== void 0 ? _a : 0;
    const goToNextItem = useCallback(() => {
        setCurrentItemIndex((prevItemIndex) => {
            var _a;
            const index = (_a = itemsIndex === null || itemsIndex === void 0 ? void 0 : itemsIndex.indexOf(prevItemIndex)) !== null && _a !== void 0 ? _a : -1;
            const nextIndex = (index + 1) % itemsCount;
            const newItemIndex = itemsIndex === null || itemsIndex === void 0 ? void 0 : itemsIndex[nextIndex];
            return newItemIndex;
        });
    }, [itemsCount, itemsIndex]);
    const goToPrevItem = useCallback(() => {
        setCurrentItemIndex((prevItemIndex) => {
            var _a;
            const index = (_a = itemsIndex === null || itemsIndex === void 0 ? void 0 : itemsIndex.indexOf(prevItemIndex)) !== null && _a !== void 0 ? _a : -1;
            const prevIndex = (index - 1 + itemsCount) % itemsCount;
            const newItemIndex = itemsIndex === null || itemsIndex === void 0 ? void 0 : itemsIndex[prevIndex];
            return newItemIndex;
        });
    }, [itemsCount, itemsIndex]);
    const handleItemClick = useCallback((itemIndex) => {
        setCurrentItemIndex(itemIndex);
    }, []);
    const handleMouseItemEnter = () => {
        setIsPaused(true);
    };
    const handleMouseItemLeave = () => {
        setIsPaused(false);
    };
    useEffect(() => {
        timerRef.current = setInterval(() => {
            if (!isPaused) {
                goToNextItem();
            }
        }, interval * 1000);
        return () => {
            if (timerRef.current) {
                clearInterval(timerRef.current);
                timerRef.current = null;
            }
        };
    }, [interval, isPaused, goToNextItem]);
    return {
        currentItem,
        handleItemClick,
        goToNextItem,
        goToPrevItem,
        handleMouseItemEnter,
        handleMouseItemLeave,
    };
};
export default useScrollingBannerTimer;
